var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.mysqlTlsVersionItems,"label":"TLS version","rules":_vm.tlsVersionRules,"dense":"","outlined":"","required":""},model:{value:(_vm.$attrs),callback:function ($$v) {_vm.$attrs=$$v},expression:"$attrs"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }